import dayjs from 'dayjs';
import {CREATOR_STATUS} from '../types/creatorTabTypes';
import type {CampaignCreatorRow} from '../types/creatorTabTypes';

export const APPLICATION_EXPIRATION_SOON_HOURS = 168;
export const APPLICATION_EXPIRATION_EXTENSION_DAYS = 14;

export function isApplicationExpiringSoon(
  expiresAt: string | null | undefined,
  now = Date.now()
): boolean {
  if (!expiresAt) return false;
  const expiresMs = new Date(expiresAt).getTime();
  if (Number.isNaN(expiresMs)) return false;
  const soonMs = now + APPLICATION_EXPIRATION_SOON_HOURS * 60 * 60 * 1000;
  // V1 Ember uses isBetween(now, now+168h) (exclusive of the 168h bound) or isBefore(now).
  return expiresMs < soonMs;
}

export function isApplicationExpirationPast(
  expiresAt: string,
  now = Date.now()
): boolean {
  const expiresMs = new Date(expiresAt).getTime();
  if (Number.isNaN(expiresMs)) return false;
  return expiresMs < now;
}

export function addApplicationExpirationExtension(
  expiresAt: string | null | undefined
): string | null {
  if (!expiresAt) return null;
  const expiresMs = new Date(expiresAt).getTime();
  if (Number.isNaN(expiresMs)) return null;
  return dayjs(expiresAt)
    .add(APPLICATION_EXPIRATION_EXTENSION_DAYS, 'day')
    .toISOString();
}

export function shouldShowApplicationExpirationAffordance(
  creator: Pick<CampaignCreatorRow, 'applicantStatus' | 'expiresAt'>
): boolean {
  return (
    creator.applicantStatus === CREATOR_STATUS.Applications &&
    isApplicationExpiringSoon(creator.expiresAt)
  );
}

export function canExtendApplicationExpiration(
  creator: Pick<
    CampaignCreatorRow,
    'applicantStatus' | 'expiresAt' | 'expirationHasBeenExtended' | 'paidGigId'
  >
): boolean {
  return (
    shouldShowApplicationExpirationAffordance(creator) &&
    !creator.expirationHasBeenExtended &&
    !!creator.paidGigId
  );
}
